import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/**
 * `question_prompt` — pergunta estruturada GENÉRICA no slot `composer` (estilo
 * AskUserQuestion): uma pergunta + N opções clicáveis resolvidas
 * ESTRUTURALMENTE via challengeId, nunca por prosa interpretada pelo LLM.
 * Toda a copy (pergunta, labels, replyText) chega LOCALIZADA do servidor
 * (strings.ts do domínio emissor) — o card não tem copy própria, de propósito.
 */
export const QuestionPromptOptionSchema = z
  .object({
    id: z.string().min(1).max(64),
    label: z.string().min(1).max(120),
    sublabel: z.string().min(1).max(120).optional(),
    /** IATA da cia — renderiza o `AirlineLogo` padronizado; ausente = só chip. */
    airlineIata: z.string().min(2).max(3).optional(),
    /** Sentença completa que vira o balão do usuário; ausente = `label`. */
    replyText: z.string().min(1).max(280).optional(),
  })
  .strict();
export type QuestionPromptOption = z.infer<typeof QuestionPromptOptionSchema>;

export const QuestionPromptBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('question_prompt'),
    challengeId: z.string().min(1),
    question: z.string().min(1).max(280),
    // Ids únicos: o pick ecoa só o `optionId` e o consumidor resolve por
    // busca — um id duplicado selecionaria a opção errada em silêncio
    // (mesma regra do refine de ids do `ChatUiMessageSchema`).
    options: z
      .array(QuestionPromptOptionSchema)
      .min(1)
      .max(8)
      .refine(
        (opts) => new Set(opts.map((o) => o.id)).size === opts.length,
        'question_prompt: ids de opção duplicados',
      ),
  })
  .strict();
export type QuestionPromptBlock = z.infer<typeof QuestionPromptBlockSchema>;

/**
 * Payload ecoado em `confirmation.selections` — `action` literal único que não
 * colide com as selections discriminadas dos outros cards (guard em cascata).
 */
export const QuestionPromptSelectionSchema = z
  .object({ action: z.literal('select_option'), optionId: z.string().min(1) })
  .strict();
export type QuestionPromptSelection = z.infer<typeof QuestionPromptSelectionSchema>;
